<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--left-small" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
  <path d="M6.41667 1L0.999999 6L6.41666 11" stroke="currentColor"/>
</svg></template>